import { Button } from '@components/Button'
import { HEADER_CONTENT_TOP_SPACING } from '@constants/layout'
import { useGetChannels } from '@services/api/graphql/channels'
import { router } from 'expo-router'
import { useTranslation } from 'react-i18next'
import { ActivityIndicator } from 'react-native'
import { Text, XStack, YStack } from 'tamagui'
import { ChannelCard } from './ChannelCard'

export function ChannelsList() {
  const { t } = useTranslation('Messages')

  const { channels, loading, loadingMore, hasMore, loadMore, error, refetch } =
    useGetChannels()

  const isEmpty = !loading && channels.length === 0

  return (
    <YStack
      marginTop={HEADER_CONTENT_TOP_SPACING}
      gap="$spacing-inset-md"
      paddingVertical="$spacing-inset-xs"
      paddingHorizontal="$size.spacing-xs"
      $gtSm={{ paddingHorizontal: '$size.spacing-xsl' }}
      testID="channels-list"
    >
      <XStack alignItems="center" justifyContent="space-between">
        <Text
          fontFamily="$mulishBold"
          fontSize="$font-size-md"
          color="$accent"
          fontWeight="bold"
        >
          {t('title')}
        </Text>
        <Button
          variant="primary"
          size="small"
          onPress={() => router.push('/channels/new')}
          testID="channels-list-new"
        >
          {t('newMessage')}
        </Button>
      </XStack>

      {loading && channels.length === 0 && (
        <YStack alignItems="center" py="$spacing-inset-lg">
          <ActivityIndicator size="large" />
        </YStack>
      )}

      {error && (
        <YStack
          alignItems="center"
          gap="$spacing-inset-xs"
          py="$spacing-inset-lg"
          testID="channels-list-error"
        >
          <Text
            fontFamily="$mulishRegular"
            fontSize="$font-size-xxs"
            color="$danger-300"
            textAlign="center"
          >
            {t('loadError')}
          </Text>
          <Button
            variant="secondary"
            size="small"
            onPress={() => refetch()}
            testID="channels-list-retry"
          >
            {t('retry')}
          </Button>
        </YStack>
      )}

      {isEmpty && !error && (
        <YStack
          alignItems="center"
          gap="$spacing-inset-nano"
          py="$spacing-inset-lg"
          testID="channels-list-empty"
        >
          <Text
            fontFamily="$mulishBold"
            fontSize="$font-size-xs"
            color="$text-primary"
            textAlign="center"
          >
            {t('emptyState.title')}
          </Text>
          <Text
            fontFamily="$mulishRegular"
            fontSize="$font-size-xxs"
            color="$text-placeholder"
            textAlign="center"
          >
            {t('emptyState.description')}
          </Text>
        </YStack>
      )}

      <YStack gap="$spacing-inset-sm">
        {channels.map((channel) => (
          <ChannelCard key={channel.id} channel={channel} />
        ))}
      </YStack>

      {hasMore && (
        <Button
          variant="secondary"
          size="small"
          onPress={() => loadMore()}
          disabled={loadingMore}
          loading={loadingMore}
          testID="channels-list-load-more"
        >
          {t('loadMore')}
        </Button>
      )}
    </YStack>
  )
}
